export const products = [
  {
    id: 1,
    name: "Pre Cleaner Max",
    category: "Cleaning",
    tagline: "First Step to Quality",
    hp: "2–3 HP",
    description:
      "Pre Cleaner separates the heavier impurities like stones, dust, straw from the paddy. This machine is designed with two long model trays. When paddy passes from the top to bottom through flaps, dust is aspirated and removed by a strong aspiration blower. In the next stage 'Dust free Paddy' enters in the pre cleaner's top tray.",
    specs: [
      { model: "Pre Cleaner", capacity: "2 - 3 Ton/Hr", power: "2 HP / 1440RPM" },
      { model: "Pre Cleaner", capacity: "4 - 6 Ton/Hr", power: "3 HP / 1440RPM" },
    ],
    color: "#1a5276",
    image: "/precleaner_max.jpeg",
  },
  {
    id: 2,
    name: "Paddy Cleaner",
    category: "Cleaning",
    tagline: "Purity Before Processing",
    hp: "2-3 HP",
    description:
      "Paddy Cleaner cleans impurities like stones, dust and straw from the paddy. This cleaning machine is designed with one inclined vibrating screen along with rotary drum and blower. The paddy is delivered to this machine uniformly. With the help of rotation, rotary drum paddy moves to the vibrator screen where heavier impurities like stones, straware are separated over the drum and sent to impurity outlet. The principle involved in separating stones is due to the difference in gravity.",
    specs: [
      { model: "Paddy Cleaner", capacity: "2-3 Ton/Hr", power: "2/960 – 5/1440" },
      { model: "Paddy Cleaner", capacity: "3-4 Ton/Hr", power: "3/960 – 5/1440" },
    ],
    color: "#2e7d32",
    image: "/paddy_cleaner.jpeg",
  },
  {
    id: 3,
    name: "Vibro Destoner",
    category: "Cleaning",
    tagline: "Stone-Free Precision",
    hp: "3-5 HP",
    description:
      "Vibro Paddy Destoner is meant to clean paddy and removes dust impurities and stones. The machine consists of two mainly vibro motors and screen frames. The material is delivered to the main machine at a uniform rate by the vibro motors. The machine will be vibrated in oscillating motion with the help of blower attached to vibro paddy destoner.",
    specs: [
      { model: "Pc7f00", capacity: "2 Ton/Hr", power: "7.5 H.P/0.25 X2nos", speed: "2800/960" },
      { model: "Pc6f00", capacity: "4 Ton/Hr", power: "7.5 H.P/0.25 X2nos", speed: "2800/960/1440" },
      { model: "Pc8f00", capacity: "6 Ton/Hr", power: "10 H.P/0.4 X2nos", speed: "2800/960/1440" },
    ],
    color: "#6a1520",
    image: "/vibro_paddy_destoner.jpeg",
  },
  {
    id: 4,
    name: "Pneumatic Husker",
    category: "Husking",
    tagline: "90% Shelling Efficiency",
    hp: "10–15 HP",
    description:
      "Sri Sai pneumatic rubber sheller is used for de-husking paddy. The machine is fitted with two rubber rolls which run in opposite directions with special cooling system to increase the rubber rolls' life. This machine is capable of up to 90% shelling efficiency. The sensor automatically adjusts the system when the paddy flow is stopped, disengaging the rubber rolls to increase their life.",
    specs: [
      { model: "Pneumatic Husker", capacity: "4 Ton/Hr", power: "10HP / 960 RPM" },  
          { model: "Pneumatic Husker", capacity: "6 Ton/Hr", power: "12.5-15HP / 960 RPM" },

    ],
    color: "#4a235a",
    image: "/pneumatic_husker.jpeg",
  },
  {
    id: 5,
    name: "Pneumatic Husker with Vibrator",
    category: "Husking",
    tagline: "Advanced Vibration Technology",
    hp: "10–15 HP",
    description:
      "Sri Sai pneumatic rubber sheller with vibrator is used for de-husking paddy. The machine is fitted with two rubber rolls with special cooling system. As the paddy flows into the threadhopper and reaches the level of the sensor and shutter it activates. The paddy flown through the inclined feed shutter in between the two rubber rolls gets shelled due to friction.",
    specs: [
      { model: "Rs5f152", capacity: "4 Ton/Hr", power: "12.5HP/960RPM", speed: "1270RPM" },
    ],
    color: "#7d3c0a",
    image: "/pneumatic_with_vibro.jpeg",
  },
  {
    id: 6,
    name: "Husk Aspirator (S.S)",
    category: "Husking",
    tagline: "Husk Separation Made Simple",
    hp: "3 HP",
    description:
      "The main function of Husk Aspirator is to separate the Husk from the Shelled paddy. The powerful Blower helps in separation of Husk. The shelled paddy is allowed to flow through the flaps arranged in a special design, which helps Husk free rice and paddy mixture at delivery end and immature paddy are separated with the help of conveyor separately.",
    specs: [
      { model: "Husk Aspirator", capacity: "2–6 Ton/Hr", power: "3-5 HP / 1440 RPM" },
    ],
    color: "#1a5f4a",
    image: "/husky_ss.jpeg",
  },
  {
    id: 7,
    name: "Paddy Separator Deluxe",
    category: "Separation",
    tagline: "3-Way Precision Separation",
    hp: "2 HP",
    description:
      "Paddy Separator Delux can be used to separate the brown rice and paddy. The machine consists of no. of trays (3, 4, 5, & 7) depending upon capacity. It works on the principal of gravity. Trays can be adjustable for better separation. It separates in 3 categories: 1. Pure Brown Rice, 2. Brown Rice with paddy, 3. Pure Paddy.",
    specs: [
      { model: "Ps3f43", capacity: "2-3 Ton/Hr", power: "2HP/960 RPM", speed: "224 RPM" },
    
    ],
    color: "#2c4a1a",
    image: "/paddy_deluxe.jpeg",
  },
  {
    id: 8,
    name: "Paddy Separator Single Deck",
    category: "Separation",
    tagline: "Single Deck Precision Gravity Separation",
    hp: "2 HP",
    description:
      "The Paddy Separator Single Deck is designed for efficient separation of brown rice from paddy using gravity principle. A single deck tray configuration delivers clean separation in a compact footprint, ideal for smaller capacity mills requiring reliable output.",
    specs: [
      { model: "Single Deck", capacity: "2-4 Ton/Hr", power: "2HP / 960 RPM", speed: "224 RPM" },
    ],
    color: "#1b5e20",
    image: "/paddy_single.jpeg",
  },
  {
    id: 9,
    name: "Paddy Separator Double Deck",
    category: "Separation",
    tagline: "Double the Throughput, Double the Precision",
    hp: "5 HP",
    description:
      "The Paddy Separator Double Deck features two tray decks for higher throughput and superior separation accuracy. Ideal for large-capacity mills, it separates pure brown rice, brown rice with paddy, and pure paddy simultaneously across both decks with gravity-based oscillation.",
    specs: [
      { model: "Double Deck", capacity: "4–6 Ton/Hr", power: "5HP / 960 RPM", speed: "224 RPM" },
    ],
    color: "#33691e",
    image: "/paddy_double.jpeg",
  },
  {
    id: 10,
    name: "Rice Whitener",
    category: "Milling",
    tagline: "Bran Removal Without Damage",
    hp: "30–40 HP",
    description:
      "The Whitener is specially designed to remove the bran layer without damaging the Rice. The whitening effect is carried out by vertically maintained abrasive rollers in the adjustable screen chamber. The machine is provided with powerful blowers to create a negative pressure. The polishing is controlled by adjustable screen holding mechanism.",
    specs: [
    
      { model: "Mw2f00", capacity: "2 Ton/Hr", power: "25H.P-960/1440", speed: "900RPM" },
      { model: "Mw4f00", capacity: "3 Ton/Hr", power: "30H.P-960/1440", speed: "870RPM" },
      { model: "Mwmf00", capacity: "4 Ton/Hr", power: "30/40H.P-960/1440", speed: "790RPM" },   
         { model: "Mwmf00", capacity: "6 Ton/Hr", power: "40/50H.P-960/1440", speed: "790RPM" },

    ],
    color: "#0d3349",
    image: "/rice_white.jpeg",
  },
  {
    id: 11,
    name: "Glaze Master with Silky",
    category: "Milling",
    tagline: "The Silk-Smooth Finish",
    hp: "25–30 HP",
    description:
      "Glaze Master Cum Silky is suitable to give glaziness on rice. The machine consists of specially designed milling roller with feed screw and high speed cooling blower to cool the rice and minimize breakage. The degree of polishing and glazing on rice can be adjusted by the weight set arrangement. A special water jet device is provided to get silk rice.",
    specs: [
      { model: "Glaze Master", capacity: "2 Ton/Hr", power: "25 HP / 960 RPM + 2 HP / 2800 RPM" },
            { model: "Glaze Master", capacity: "4 Ton/Hr", power: "30 HP / 960 RPM + 2 HP / 2800 RPM" },

    ],
    color: "#5d4037",
    image: "/glaze_master.jpeg",
  },
  {
    id: 12,
    name: "Silky Polisher",
    category: "Polishing",
    tagline: "Crystal-Clear Final Polish",
    hp: "30 HP",
    description:
      "The Silky polisher is used in the final stage of processing to produce rice with a smooth dust-free surface which flows freely like water through the fingers. Clear transparent packs which show the contents are an ideal way to pack high poly processed rice, which with its high glass and pearly luster makes it a highly visible and attractive product on market shelves.",
    specs: [
      { model: "Silky", capacity: "3 Ton/Hr", power: "30 HP / 1440RPM", voltage: "415V / 50HZ", dims: "1080 × 570 × 1400 mm" },
    ],
    color: "#1a3a2a",
    image: "/silky_polish.jpeg",
  },
  {
    id: 13,
    name: "Rice Shifter",
    category: "Grading",
    tagline: "Separate Tips & Broken Rice",
    hp: "1.5–2 HP",
    description:
      "Rice Shifter with Aspirator is designed for the separation of tips and broken rice from head rice while simultaneously aspirating dust and light impurities. The machine is well-built, low in maintenance and easy to operate, delivering clean graded output.",
    specs: [
      { model: "Shifter", capacity: "2 - 3 Ton/Hr", power: "1.5HP / 960 RPM" },
            { model: "Shifter", capacity: "3-4 Ton/Hr", power: "2HP / 960 RPM" },
      { model: "Shifter", capacity: "6 Ton/Hr", power: "2HP / 960 RPM" },

    ],
    color: "#3e2723",
    image: "/rice_shift.jpeg",
  },
  {
    id: 14,
    name: "Air Lock System",
    category: "Support",
    tagline: "Superior Bran Separation",
    hp: "10–15 HP",
    description:
      "The Air Lock System contains a set of CI Blowers and Cyclones in which germs can be separated most conveniently and the fine bran will be better separated compared to the convention types of bran separation equipments.",
    specs: [
      { model: "Air Lock System", capacity: "3–4 Ton/Hr", power: "10HP/2880RPM + 1HP/1440RPM" },
            { model: "Air Lock System", capacity: "4-5 Ton/Hr", power: "12.5-15HP/2880RPM + 1HP/1440RPM" },

    ],
    color: "#004d40",
    image: "/air_lock.jpeg",
  },
  {
    id: 15,
    name: "Bran Processing",
    category: "Support",
    tagline: "Maximum Value from Every Grain",
    hp: "2–5 HP",
    description:
      "The Bran Processing unit efficiently handles bran extracted during whitening and polishing stages. It ensures clean, dry bran output suitable for further processing or sale, minimizing waste and maximizing mill profitability.",
    specs: [
      { model: "Bran Processing", capacity: "2 Ton/Hr", power: "2 HP / 1440 RPM" },
            { model: "Bran Processing", capacity: "3-4 Ton/Hr", power: "3 HP / 1440 RPM" },
            { model: "Bran Processing", capacity: "4–6 Ton/Hr", power: "3-5 HP / 1440 RPM" },
    ],
    color: "#4e342e",
    image: "/bran.jpeg",
  },
  {
    id: 16,
    name: "Dust Blower",
    category: "Support",
    tagline: "Clean Air, Clean Rice",
    hp: "2–15 HP",
    description:
      "The Dust Blower is a high-efficiency centrifugal blower used throughout the milling process to remove dust, husk particles, and fine impurities via pneumatic conveyance. Available in multiple power configurations to match the required airflow capacity of any mill size.",
    specs: [
      { model: "Dust Blower", capacity: "As required", power: "2–15 HP / 2880 RPM" },
    ],
    color: "#37474f",
    image: "/dust.jpeg",
  },
  {
    id: 17,
    name: "Single Grain Discharger",
    category: "Support",
    tagline: "Smooth, Controlled Grain Flow",
    hp: "1–3 HP",
    description:
      "The Single Grain Discharger provides controlled, uniform discharge of rice or paddy from storage hoppers or elevators. It ensures a steady, regulated flow to downstream machinery, preventing overloading and maintaining consistent throughput.",
    specs: [
      { model: "Single Discharger", capacity: "2–6 Ton/Hr", power: "1–5 HP / 1440 RPM" },
    ],
    color: "#263238",
    image: "/single_discharge.jpeg",
  },
  {
    id: 18,
    name: "Double Grain Discharger",
    category: "Support",
    tagline: "Dual-Channel Discharge Precision",
    hp: "1.5–3 HP",
    description:
      "The Double Grain Discharger features two independent discharge channels for simultaneous controlled flow to two separate downstream machines. Ideal for high-capacity mills requiring split feed to parallel processing lines, ensuring uniform and uninterrupted material flow.",
    specs: [
      { model: "Double Discharger", capacity: "2–6 Ton/Hr", power: "2–5 HP / 1440 RPM" },
    ],
    color: "#1a237e",
    image: "/double_discharge.jpeg",
  },
{
  id: 19,
  name: "Rice Colour Sortex",
  category: "Sorting",
  tagline: "Precision Color Sorting Technology",
  hp: "10–50 HP",
  description:
    "Rice Colour Sortex is an advanced sorting machine designed to separate grains based on color, size, and shape. Equipped with high-speed true color CCD sensors and intelligent sorting technology, it ensures superior grain quality, high accuracy, and efficient processing. The system supports multiple sorting profiles, making it suitable for a wide range of rice varieties and sorting requirements.\n\n• Intelligent sorting based on color, size, and shape.\n• High-speed super high-definition true color 5400×3 CCD sensors.\n• Rapid detection rate of 30,000 granules per second.\n• Stores hundreds of sorting profiles for versatile operation.\n• 15-inch HD operation control panel with 1080P display.\n• Intelligent control system for easy operation.\n• Shadowless cold light source with automatic luminance adjustment.\n• High-frequency solenoid valves with over 12 billion cycle lifespan.",
  specs: [
    {
      model: "Rice Colour Sortex",
      capacity: "1-10 Chutes",
      power: "10-50 HP"
    }
  ],
  color: "#8e44ad",
  image: "/rice_colour_sortex.jpeg",
}
];

export const categories = ["All", "Cleaning", "Husking", "Separation", "Milling", "Polishing", "Grading", "Support"];